import { useState } from "react";
import SelectInput, { SelectInputProps } from "./SelectInput";
import TextInput from "./TextInput";

type SelectInputWithSearchProps = {} & SelectInputProps;

export default function SelectInputWithSearch(props: SelectInputWithSearchProps) {
    const { dropdownOptions, ...rest } = props;
    const [searchValue, setSearchValue] = useState("");

    const filteredDropdownOptions = dropdownOptions?.filter(
        (option) =>
            option.label?.toString().toLowerCase().includes(searchValue.toLowerCase()) ||
            option.subText?.toString().toLowerCase().includes(searchValue.toLowerCase())
    );

    return (
        <SelectInput
            customDropdownContainer={
                <TextInput
                    inputPlaceholder="Search"
                    value={searchValue}
                    onChange={(e) => {
                        setSearchValue(e.target.value);
                    }}
                    inputContainerClassname="max-sm:!w-full !pl-[10px] !border-b !border-t-0 !border-l-0 !border-r-0 !border-n-20"
                    leftIcon={
                        <i className="ri-search-line before:content-['\f0d1] text-slate-400 mt-[2px]"></i>
                    }
                />
            }
            dropdownOptions={filteredDropdownOptions}
            {...rest}
        />
    );
}
